import { useEffect } from 'react';

import startupThemeToCSSVariables from 'startup-theme-to-css-variables';

function useStartupTheme(startup, supportedFonts = []) {

  useEffect(function addStyleSheet() {

    if (startup === null) {
      return;
    }

    const theme = startup.theme;

    const sheet = document.createElement('style');
    sheet.innerHTML = themeToStyleSheet(theme);

    document.head.appendChild(sheet);

    const cssVariablesSheet = document.createElement('style');
    cssVariablesSheet.innerHTML = startupThemeToCSSVariables(startup, supportedFonts) + startupThemeToCSSVariables.startupThemeToCalendarCSSVariables(startup);

    document.head.appendChild(cssVariablesSheet);

    return function removeStyleSheet() {

      sheet.parentNode.removeChild(sheet);
      cssVariablesSheet.parentNode.removeChild(cssVariablesSheet);

    };

  }, [startup]);

}

function themeToStyleSheet(theme) {

  const styleSheet = `
  
    `;

  return styleSheet;

}

export default useStartupTheme;